export enum EnumEstadoOferta {
  Borrador = 1,
  Publicada = 2,
  Historica = 3,
  Baja = 4,
  Pendiente = 5,
  Regenerada = 6
}
